import axios from "axios";
import { Base_Url } from "./baseurl";
import { apiGetHelper, apiPostHelper } from "../helpers/apiHelper";


const urlParams = new URLSearchParams(window?.location?.search);
const GetWebId =  urlParams?.get("auth");
console.log(GetWebId,'GetWebId');

export const UserDeatils = async (data) => {
let result;
  try {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // Ensure token is set in headers
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    if (GetWebId === "success") {
      // Add isGoogleAuth flag to the data for Google authentication
      data = { ...data, isGoogleAuth: true };
    }
    
    result = await apiPostHelper("post", `${Base_Url.base_url}/login`, data);

    if (result?.data?.user?.telegramId) {
      localStorage.setItem(
        `tutorialStatus_${result?.data?.user?.telegramId}`,
       (result?.data?.user?.tutorialStatus)
      );
      localStorage.setItem(
        `level_${result?.data?.user?.telegramId}`,
        JSON.stringify(result?.data?.user?.level)
      );
      localStorage.setItem(
        `TutorialIcon_${result?.data?.user?.telegramId}`,
       (true)
      );   
    }
    return result?.data;
  } catch (err) {
    console.error("Error in UserDeatils:", err);
    throw err;
  }
};
export const addWatchSeconds = async (data) => {
  try {
    const response =await apiPostHelper("post",
      `${Base_Url.base_url}/userWatchRewards`,
      data
    );

    return response?.data;
  } catch (err) {}
};
export const userGameRewards = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/userGameRewards`,
      data
    );
    if (response.data && parseInt(data?.gamePoints)>0) {
      calculateStreak({ userWatchSeconds: 0 });
    }
    return response.data;
  } catch (err) {
    console.log(err);
  }
};
export const getUserDetails = async (telegramId) => {
  try {
    const response = await apiGetHelper("get",
      `${Base_Url.base_url}/userDetails`
    );
localStorage.setItem("userProfile", JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserDetails1 = async (telegramId) => {
  try {
    const response = await apiGetHelper("get",
      `${Base_Url.base_url}/userDetails`
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const purchaseGameCards = async (data) => {
  try {
    const response =await apiPostHelper("post",
      `${Base_Url.base_url}/purchaseGameCards`,
      data
    );
    return response.data.user;
  } catch (err) {
    return err.response.data.message;
  }
};

export const myReferrel = async (data) => {
  try {
    const response = await apiGetHelper("get",
      `${Base_Url.base_url}/yourReferrals?page=${1}&limit=${10000}`,
      
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const purchaseBooster = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/purchaseBooster`,
      data,
      "IsError",
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const weekRewards = async (data) => {
  try {
    const response =  await apiGetHelper("get",
      `${Base_Url.base_url}/dailyRewards?currentPhase=${data?.phase}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const stakeRewards = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/stakingRewards`,
      data
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const getPopularUser = async (telegramId) => {
  try {
    const response =  await apiGetHelper("get",
      `${Base_Url.base_url}/popularUser`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserStreaks = async (telegramId) => {
  try {
    const response = await apiGetHelper("get",
      `${Base_Url.base_url}/userStreaks`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const calculateStreak = async (data) => {
  try {
    const response = await apiPostHelper("post",`${Base_Url.base_url}/streak`, data);
    return response.data;
  } catch (err) {}
};
export const calculateStreakOfStreak = async (data) => {
  try {
    const response = await apiPostHelper("post",`${Base_Url.base_url}/streakOfStreak`, data,"StreakOfStreak")

    return response.data;
  } catch (err) {
    if (err.response) {
      // Extract the backend-defined error message
      return err.response.data;
    } else {
      return err;
    }
  }
};
export const loginStreakRewardClaim = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/loginStreakRewardClaim`,
      data
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      // Extract the backend-defined error message
      return err.response.data;
    } else {
      return err;
    }
  }
};
export const watchStreakRewardClaim = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/watchStreakRewardClaim`,
      data
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      // Extract the backend-defined error message
      return err.response.data;
    } else {
      return err;
    }
  }
};
export const referStreakRewardClaim = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/referStreakRewardClaim`,
      data
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      // Extract the backend-defined error message
      return err.response.data;
    } else {
      return err;
    }
  }
};
export const taskStreakRewardClaim = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/taskStreakRewardClaim`,
      data
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      // Extract the backend-defined error message
      return err.response.data;
    } else {
      return err;
    }
  }
};
export const multiStreakRewardClaim = async (data) => {
  try {
    const response =  await apiPostHelper("post",
      `${Base_Url.base_url}/multiStreakRewardClaim`,
      data
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      // Extract the backend-defined error message
      return err.response.data;
    } else {
      return err;
    }
  }
};
export const streakOfStreakRewardClaim = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/streakOfStreakRewardClaim`,
      data
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      // Extract the backend-defined error message
      return err.response.data;
    } else {
      return err;
    }
  }
};

export const cheapStuff = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/userTaskRewards`,
      data
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      // Extract the backend-defined error message
      return err.response.data;
    } else {
      return err;
    }
  }
};

export const userWalletAddress = async (data) => {
  try {
    const response = await apiPostHelper("post",
      `${Base_Url.base_url}/addWalletAddress`,
      data, "IsError"
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const TutorialUpdate = async (data) => {
  try {
    const response =await apiPostHelper("post",
      `${Base_Url.base_url}/tutorialStatus`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const fetchCurrentDateTime = async () => {
  try {
    const response = await axios.get('http://worldtimeapi.org/api/timezone/Etc/UTC');
      const utcDatetime = response.data.utc_datetime;
      localStorage.setItem(`currentDate`,utcDatetime)
      return utcDatetime;   
     } catch (error) {
    if (error.response) {
      console.error("Error response:", error.response.status, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error setting up the request:", error.message);
    }
    return null;
  }
};

export const BoosterList = async (data) => {
  try {
    const response =await apiGetHelper("get",
      `${Base_Url.base_url}/boosterDetails/`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const EarlyRewardClaim = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/validatePromocode`,
      data,
      "IsError"
    );
    return { success: true, data: response?.data };
  } catch (error) {
    console.log(error);
    
    // Extract error message from the backend response
    const errorMessage =
      error?.response?.data?.message || "Something went wrong. Please try again.";
      console.log(errorMessage,'kjhkj');
      
    
    return { success: false, error: errorMessage };
  }
};

export const GameLeaderBoardApi = async(type,telegramId)=>{
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/gameLeaderBoard?type=${type}&telegramId=${telegramId}`,
      "IsError"
    );
    return { success: true, data: response?.data };
  } catch (error) {
    console.log(error);
    
    // Extract error message from the backend response
    const errorMessage =
      error?.response?.data?.message || "Something went wrong. Please try again.";
      console.log(errorMessage,'kjhkj');
      
    
    return { success: false, error: errorMessage };
  }
}


export const GeneratePromoCode = async(data)=>{
  try{
    console.log(data,'data');
    
    const response = await apiPostHelper("post",`${Base_Url.base_url}/allocatePromoCodeRewards`,data,
      "IsError"
    );
    return { success: true, data: response?.data };
  }
  catch(error){
    console.log(error);
    return { success: false, error: error?.response?.data?.message || "Failed to generate promo code" };
  }
}

export const PromoHistoryApi = async(telegramId)=>{
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/userPromoCodes`,
      "IsError"
    );
    return { success: true, data: response?.data };
  } catch (error) {
    console.log(error);
    
    // Extract error message from the backend response
    const errorMessage =
      error?.response?.data?.message || "Something went wrong. Please try again.";
      console.log(errorMessage,'kjhkj');
      
    return { success: false, error: errorMessage };
  }
}

export const checkRefId = async (refId) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/checkRefId/${refId}`,
      "IsError"
    );
    return { success: true, data: response?.data };
  } catch (error) {
    console.log(error);
    
    // Extract error message from the backend response
    const errorMessage =
      error?.response?.data?.message || "Something went wrong. Please try again.";
    
    return { success: false, error: errorMessage };
  }
}

export const LoginWithGoogleApi = async (refId) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/webapp/auth?provider=google`,
      "IsError"
    );
    return { success: true, data: response?.data };
  } catch (error) {
    console.log(error);
    
    // Extract error message from the backend response
    const errorMessage =
      error?.response?.data?.message || "Something went wrong. Please try again.";
    
    return { success: false, error: errorMessage };
  }
}

export const telegramAuthToken = async (rawInitDataString) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${Base_Url.base_url}/webapp/auth/telegram/login`,
      data: {
        initData: rawInitDataString ? rawInitDataString : "query_id=AAGy955YAAAAALL3nlhl_lVw&user=%7B%22id%22%3A1486813106%2C%22first_name%22%3A%22Danicka%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22DanickaRufus%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FSNmcgo9lqbUUKYXAyZQqDSF9ZCXiu7qsbm6arWrJcJM.svg%22%7D&auth_date=1772349150&signature=VfNzBeOQPqaFNNk0WiFGY9QqLyDxylrDpn-aZGbyBpmV_4Vd6PVnpBtb3B0-v2AyvM9aNjwNU-dJXZB-UvaCBA&hash=13d474e120244b12874acb8862fc8a453d5d6e081ae3eb58869441f576b4e00b"
      }
    });

    if (response.data) {
      const { jwtToken, user } = response.data;
      // Store the JWT token in localStorage so it can be used for subsequent API calls
      localStorage.setItem('token', jwtToken);
      localStorage.setItem('user', JSON.stringify(user));
      
      // Set the token in axios defaults for all future requests
      axios.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
      
      return jwtToken;
    }
    return null;
  } catch (err) {
    console.error("Telegram authentication error:", err);
    return null;
  }
};

export const GAuthToken = async (rawInitDataString) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${Base_Url.base_url}/get-token`,
      withCredentials: true,
      params: { isGoogleAuth: true }
    });
    if (response.data) {
      const { jwtToken } = response.data;
      // Store the JWT token in localStorage
      localStorage.setItem('token', jwtToken);
      // Set the token in axios defaults for all future requests
      axios.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
      return { success: true, token: jwtToken };
    }
    return { success: false, error: 'No token received' };
  } catch (err) {
    console.error("Google authentication error:", err);
    return { success: false, error: err.message };
  }
};





export const getDailyRewardsConfig = async (telegramId) => {
  try {
    const response = await apiGetHelper("get",
      `${Base_Url.base_url}/dailyRewardsConfig?telegramId=${telegramId}`,"IsError"
    );
    return { success: true, data: response?.data };
  } catch (err) {
    console.error("Error in getDailyRewardsConfig:", err);
    return { success: false, error: err?.response?.data?.message || "Failed to fetch daily rewards config" };
  }
};

export const claimDailyReward = async (data) => {
  try {
    console.log("claimDailyReward called with:", data);
    // const response = await apiPostHelper("post",
    //   `${Base_Url.base_url}/claimDailyReward`,
    //   data
    // );
    
    // Get the token from localStorage
    const token = localStorage.getItem('token');
    
    // Set up headers
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    const response = await axios({
      method: 'post',
      url: `${Base_Url.base_url}/claimDailyReward`,
      data: data,
      headers: headers
    });
    
    return { success: true, data: response?.data };
  } catch (err) {
    console.error("Error in claimDailyReward:", err);
    return { success: false, error: err?.response?.data?.message || "Failed to claim daily reward" };
  }
};

export default {
  UserDeatils,
  addWatchSeconds,
  userGameRewards,
  getUserDetails,
  purchaseGameCards,
  myReferrel,
  purchaseBooster,
  weekRewards,
  getPopularUser,
  getUserStreaks,
  calculateStreak,
  calculateStreakOfStreak,
  loginStreakRewardClaim,
  watchStreakRewardClaim,
  referStreakRewardClaim,
  taskStreakRewardClaim,
  multiStreakRewardClaim,
  streakOfStreakRewardClaim,
  cheapStuff,
  getUserDetails1,
  userWalletAddress,
  TutorialUpdate,
  GeneratePromoCode,
  PromoHistoryApi,
  checkRefId,
  telegramAuthToken,
  GAuthToken,
  getDailyRewardsConfig,
  claimDailyReward
};
